module.exports = __webpack_public_path__ + "static/media/coming_soon.85cd6e91.jpg";